import { cn } from '@/lib/utils';

interface SelectionButtonProps {
  children: React.ReactNode;
  selected: boolean;
  onClick: () => void;
  icon?: string;
  variant?: 'card' | 'pill' | 'segmented';
  className?: string;
}

export function SelectionButton({
  children,
  selected,
  onClick,
  icon,
  variant = 'pill',
  className
}: SelectionButtonProps) {
  if (variant === 'segmented') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'w-full py-3 text-center font-bold rounded-xl transition-colors',
          selected
            ? 'bg-primary text-black shadow-md'
            : 'text-text-primary-dark dark:text-text-primary-dark',
          className
        )}
      >
        {children}
      </button>
    );
  }

  if (variant === 'card') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'flex flex-col items-center justify-center gap-2 rounded-lg py-2.5 transition-colors',
          selected
            ? 'border-2 border-primary bg-primary/10 text-primary'
            : 'border border-border-color bg-transparent text-text-muted hover:border-gray-400 dark:hover:border-gray-500',
          className
        )}
      >
        {icon && (
          <span className="material-symbols-outlined text-primary" style={{ fontSize: '28px' }}>{icon}</span>
        )}
        <span className={cn('text-sm font-semibold', selected ? 'text-primary' : '')}>{children}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex-1 rounded-lg py-2.5 text-sm font-semibold transition-colors',
        selected
          ? 'border-2 border-primary bg-primary/10 text-primary'
          : 'border border-border-color bg-transparent text-text-muted hover:border-gray-400 dark:hover:border-gray-500',
        className
      )}
    >
      {children}
    </button>
  );
}
